import React, { useState } from 'react';
import ViewDocHistoryPresenter from './ViewDocHistoryPresenter';
interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
  docdata?: any;
}
const ViewDocHistoryController = ({
  isModalOpen,
  closeModal,
  trans,
  docdata,
}: ModalInterface) => {
  return (
    <ViewDocHistoryPresenter
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      trans={trans}
      docdata={docdata}
    />
  );
};
export default ViewDocHistoryController;
